// extracted by mini-css-extract-plugin
module.exports = {"headerBox":"datagridheader_headerBox__3XBBH","filterBtn":"datagridheader_filterBtn__2PgTN","activeFilterIndicator":"datagridheader_activeFilterIndicator__2STfU"};